import React, { Fragment } from 'react';

const TrafficViolation = () => (
  <Fragment>
    <h4 className="subtitle">
      What do I do if I receive a traffic violation?
    </h4>
    <p>
      As a driver, you are responsible for any parking or traffic
      violations that you receive during your booking. Please follow the
      instructions on the ticket and process the payment in a timely manner
      to avoid incurring additional fees.
    </p>
    <br />
    <p>
      If we receive notice of an unpaid ticket (usually 14 days after the
      issue date), we will pay the balance owed and apply the charges to
      your account along with an administrative fee of $20.
    </p>
    <br />
    <h4 className="subtitle">Can I appeal a traffic violation?</h4>
    <p>
      No, you do not have the option to appeal a ticket. The ticket must be
      paid in full to avoid additional fees.
    </p>
    <br />
    <h4 className="subtitle">
      Am I allowed to drive on Highway 407 Express Toll Route (407 ETR)?
    </h4>
    <p>
      Yes, all Autzu vehicles have 407 ETR transponders included. Tolls
      incurred while driving on rideshare trips are charged to the riders,
      and automatically added to the fare that you earn.
    </p>
    <p>
      It takes us a few weeks to receive notice of these toll fees from 407
      ETR, therefore toll fees are usually applied at the start of the
      following month.
    </p>
    <br />
  </Fragment>
);

export default TrafficViolation;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/DrivesharingPolicies/TrafficVoilation.js